(function() {
    'use strict';

    angular.module('settings')
        .controller('BannerCreateController', BannerCreateController);

    BannerCreateController.$inject = ['$state', 'bannerDataSrvc', 'notificationSrvc', 'bannerMessagesConst', 'productCountryConst', 'pageDataSrvc', 'errorNotificationSrvc'];

    function BannerCreateController($state, bannerDataSrvc, notificationSrvc, bannerMessagesConst, productCountryConst, pageDataSrvc, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            name: [],
            url: [],
            is_published: [],
            datetime_from: [],
            datetime_to: [],
            display_time: [],
            available_in_countries: [],
            pages: [],
            image: [],
            description_pl: [],
            description_de: [],
            description_en: [],
            description_cpde: [],
            description_cpen: [],
            nonFieldErrors: []
        };

        self.bannerData = {
            name: '',
            url: '',
            is_published: true,
            datetime_from: undefined,
            datetime_to: undefined,
            display_time: 0,
            available_in_countries: [],
            pages: [],
            image: undefined,
            description_pl: '',
            description_de: '',
            description_en: '',
            description_cpde: '',
            description_cpen: ''
        };
        self.countryList = productCountryConst;
        self.pagesList = [];

        self.createBanner = createBanner;
        self.cleanErrors = cleanErrors;

        activate();

        function activate() {
            getPages();
        }

        function getPages() {
            return pageDataSrvc.bannerPages()
                .$promise.then(function(response) {
                    self.pagesList = response;
                    return response;
                });
        }

        function createBanner() {
            bannerDataSrvc.create(
                self.bannerData
            ).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", bannerMessagesConst.add);
                    $state.go('layout.banner.list');
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
